import React from 'react';

const Hero = () => {
  return (
    <div className="bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto py-20 px-4 sm:py-28 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/3 mb-10 md:mb-0">
            <div className="relative w-72 h-72 mx-auto">
              <div className="absolute inset-0 bg-blue-600 rounded-full opacity-10 transform rotate-3"></div>
              <div className="relative rounded-full w-full h-full bg-blue-100 flex items-center justify-center shadow-xl border-4 border-white overflow-hidden">
                <img
                  src="/images/profile.jpg"
                  alt="Sunil Nair"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
            </div>
          </div>
          
          <div className="md:w-2/3 md:pl-16">
            <h1 className="text-5xl font-extrabold text-blue-900 sm:text-6xl sm:tracking-tight lg:text-7xl">
              <span className="block">S N Advisor</span>
              <span className="block text-gray-600 text-4xl mt-2">Sunil Nair : Your Trusted Insurance Partner </span>
              
              
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
            Welcome! I'm Sunil Nair, a licensed insurance advisor dedicated to helping individuals and families choose the right insurance plans with confidence and clarity. With years of experience in the field, I specialize in guiding you toward policies that are not only cost-effective but truly fit your needs.
            Whether you're securing your family's future, your health, or your vehicle, I provide expert advice and personalized recommendations across a wide range of insurance categories:

            </p>
            <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-lg text-gray-700 list-none">
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Life Insurance
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Health & Mediclaim Insurance
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Vehicle Insurance
              </li>
    
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Term Plans
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Child Education & Investment Plans
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                Unit Linked Insurance Plans(ULIP)
              </li>
              <li className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-600 rounded-full"></span>
                SIP & Mutual Funds
              </li>
              
            </ul>
            <span className="block text-gray-550 text-4xl mt-2">Get in touch today - Because the right policy can make all the difference tomorrow.</span>
            <div className="mt-10 flex space-x-4">
              {/* <a
                href="#contact"
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 transition duration-150 ease-in-out shadow-lg hover:shadow-xl"
              >
                Contact Us
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center px-8 py-3 border border-blue-600 text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 transition duration-150 ease-in-out"
              >
                Our Services
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero; 